import styled from 'styled-components';

export const MobileHeaderWrapper = styled.div`
  width: 100%;
  padding: 0px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MobileHeaderRightColumnWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const MobileRectangle = styled.div`
  width: 1px;
  height: 20px;
  background: ${({ theme }) => theme.palette.whiteAlpha300};
`;
